import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../TGases.css";
import { plotBackground } from "../../../config/colors";

export default function DeltasPresionTostador() {
  const [pCargaCiclonPrimerioL2, setPCargaCiclonPrimerioL2] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [pCargaCiclonSecundariosL2, setPCargaCiclonSecundariosL2] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [pCargaCiclonPrimerioL1, setPCargaCiclonPrimerioL1] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [pCargaCiclonSecundariosL1, setPCargaCiclonSecundariosL1] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [pCargaLecho, setPCargaLecho] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [pCargaFreeboardCiclones, setPCargaFreeboardCiclones] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [pCargaCPC, setPCargaCPC] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [pCargaTEHESP, setPCargaTEHESP] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 3,
    secuencia: 32,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
    const { data } = await getValoresPeriodo(initialFetch);
    populatePCargaCiclonPrimerioL2(data);
    populatePCargaCiclonSecundariosL2(data);
    populatePCargaCiclonPrimerioL1(data);
    populatePCargaCiclonSecundariosL1(data);
    populatePCargaLecho(data);
    populatePCargaFreeboardCiclones(data);
    populatePCargaCPC(data);
    populatePCargaTEHESP(data);
      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populatePCargaCiclonPrimerioL2(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Pérdida de Carga Ciclón Primerio L2"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPCargaCiclonPrimerioL2({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePCargaCiclonSecundariosL2(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Pérdida de Carga Ciclones Secundarios L2"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPCargaCiclonSecundariosL2({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePCargaCiclonPrimerioL1(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Pérdida de Carga Ciclón Primerio L1"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPCargaCiclonPrimerioL1({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePCargaCiclonSecundariosL1(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Pérdida de Carga Ciclones Secundarios L1"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPCargaCiclonSecundariosL1({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePCargaLecho(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Pérdida de Carga Lecho"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPCargaLecho({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePCargaFreeboardCiclones(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Pérdida de Carga Freeboard-Ciclones"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPCargaFreeboardCiclones({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePCargaCPC(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Pérdida de Carga CPC"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPCargaCPC({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePCargaTEHESP(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Pérdida de Carga TE-HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPCargaTEHESP({
      fecha: arrFechas,
      value: arrValues,
    });
  }

 
  return (
    <>
       <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Deltas Presión Tostador-Tren de Gases"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- DP Ciclón Primerio L2 --------------------------------------- */}
            <Chart.Line
              name="DP Ciclón Primerio L2"
              data={pCargaCiclonPrimerioL2.value}
              yAxis={1}
            />
            {/** -------------------------------- DP Ciclones Secundarios L2 --------------------------------------- */}
            <Chart.Line
              name="DP Ciclones Secundarios L2"
              data={pCargaCiclonSecundariosL2.value}
              yAxis={1}
            />
            {/** -------------------------------- DP Ciclón Primerio L1 --------------------------------------- */}
            <Chart.Line
              name="DP Ciclón Primerio L1"
              data={pCargaCiclonPrimerioL1.value}
              yAxis={1}
            />
            {/** -------------------------------- DP Ciclones Secundarios L1 --------------------------------------- */}
            <Chart.Line
              name="DP Ciclones Secundarios L1"
              data={pCargaCiclonSecundariosL1.value}
              yAxis={1}
            />
            {/** -------------------------------- DP Lecho --------------------------------------- */}
            <Chart.Line
              name="DP Lecho"
              data={pCargaLecho.value}
              yAxis={0}
            />
            {/** -------------------------------- DP Freeboard-Ciclones --------------------------------------- */}
            <Chart.Line
              name="DP Freeboard-Ciclones"
              data={pCargaFreeboardCiclones.value}
              yAxis={1}
            />
            {/** -------------------------------- DP CPC --------------------------------------- */}
            <Chart.Line
              name="DP CPC"
              data={pCargaCPC.value}
              yAxis={1}
            />
            {/** -------------------------------- DP TE-HESP --------------------------------------- */}
            <Chart.Line
              name="DP TE-HESP"
              data={pCargaTEHESP.value}
              yAxis={1}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={pCargaCiclonPrimerioL2.fecha} />

            <Chart.YAxis
              labelSuffix=" kPa"
              title="DP Lecho, kPa"
              lineWidth={2}
              lineColor="white"
            />

            <Chart.YAxis
              labelSuffix=" kPa"
              title="DP TdG, kPa"
              lineWidth={2}
              opposite={true}
              lineColor="white"
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
